import React from 'react';
import { SearchIcon } from '@/component/Icons/SearchIcon';

export const SearchInput = React.forwardRef((props, ref) => {
  const {
    className = '',
    value,
    placeholder = 'Where',
    label = 'Search location',
    onChange,
    onKeyDown,
    onFocus,
    onBlur,
  } = props;
  return (
    <div
      className={`relative flex items-center px-3 py-3.5 border border-slate-300 rounded-10 bg-slate-50 ${className}`}
    >
      <SearchIcon size="24" aria-hidden="true" />
      <input
        ref={ref}
        className="flex-1 pl-2.5 relative top-2 outline-none bg-transparent text-slate-800 text-base font-medium leading-normal"
        id="search-input"
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        aria-labelledby="search-location-label"
      />
      <label
        className={`absolute left-9 transition-all duration-200 ease-in-out transform pl-2.5 top-1 text-slate-600 text-xs font-medium leading-[18px]`}
        htmlFor="search-input"
        id="search-location-label"
      >
        {label}
      </label>
    </div>
  );
});

SearchInput.displayName = 'SearchInput';
